import { defineMessages } from 'react-intl';

const translations = {
  properties: {
    shippingNumber: {
      label: {
        id: 'properties.shippingNumber',
        defaultMessage: 'Shipping number',
        description: 'Label of the property shipping number',
      },
    },
    shippingMethod: {
      label: {
        id: 'properties.shippingMethod',
        defaultMessage: 'Shipping method',
        description: 'Label of the property shipping method',
      },
    },
    expectedAt: {
      label: {
        id: 'properties.expectedAt',
        defaultMessage: 'Expected at',
        description: 'Label of the property expected at',
      },
    },
    shipAt: {
      label: {
        id: 'properties.shipAt',
        defaultMessage: 'Ship at',
        description: 'Label of the property ship at',
      },
    },
    toAddress: {
      label: {
        id: 'properties.toAddress',
        defaultMessage: 'To',
        description: 'Label of the property to address',
      },
    },
    fromAddress: {
      label: {
        id: 'properties.fromAddress',
        defaultMessage: 'From',
        description: 'Label of the property from address',
      },
    },
  },
  actions: {
    save: {
      id: 'actions.save',
      defaultMessage: 'Save',
      description: 'Label of the action save',
    },
  },
  feedback: {
    parcelPositionUpdated: {
      id: 'parcelDialog.feedback.parcelPositionUpdated',
      defaultMessage: 'Parcel position updated',
      description: 'Success message of the update parcel position action',
    },
    parcelPositionNotUpdated: {
      id: 'parcelDialog.feedback.parcelPositionNotUpdated',
      defaultMessage: 'Parcel position could not be updated',
      description: 'Error message of the update parcel position action',
    },
  },
};

export default defineMessages(translations);
